import React from 'react';
import bemHelper from 'react-bem-helper';
import Svg from '../svg';
import twitterSvg from '../../lib/icons/twitter.svg';
import './styles.scss';

const bem = bemHelper({ prefix: 'toga-', name: 'twitter-share' });

class ShareTwitterButton extends React.Component {
  constructor() {
    super();
    this.openWindow = this.openWindow.bind(this);
  }

  openWindow(event) {
    event.preventDefault();
    const linkUrl = this.props.linkUrl;
    const twitterShareURI = `https://twitter.com/intent/tweet?text=${encodeURIComponent(this.props.text)}&url=${linkUrl}`;
    const width = 580;
    const height = 445;
    const top = (screen.height / 2) - (height / 2);
    const left = (screen.width / 2) - (width / 2);
    window.open(twitterShareURI, 'newwindow', `width=${width}, height=${height}, top=${top}, left=${left}`); return false;
  }

  render() {
    const { text, ...props} = this.props; // eslint-disable-line
    return (
      <a { ...bem() } href="#" onClick={this.openWindow} { ...props }>
        <Svg { ...bem('svg') } markup={twitterSvg} /> <span className="sr-only">Share on Twitter</span>
      </a>
    );
  }
}

export default ShareTwitterButton;



// WEBPACK FOOTER //
// ./src/subComponents/share-twitter-button/index.js